module.exports = __webpack_public_path__ + "img/sad-face-avatar.9e4699a8.png";